var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9952 12.9883C20.5265 12.9883 20.9953 12.5507 20.9953 11.9851C21.0265 11.7038 20.9015 11.4538 20.6515 11.235L19.0014 9.78174V6.00017C19.0014 5.447 18.5544 5.00008 18.0013 5.00008H17.0012C16.448 5.00008 16.0011 5.447 16.0011 6.00017V7.14714L12.6727 4.21877C12.4852 4.06251 12.2352 4 12.0164 4C11.7976 4 11.5476 4.03125 11.3288 4.25002L3.31253 11.235C3.09376 11.4538 3 11.7038 3 11.9851C3 12.5476 3.43754 12.9883 4.00009 12.9883H5.00017V15.1666C4.99704 15.1947 4.99704 15.2228 4.99704 15.2541V18.7513C4.99704 19.4419 5.55647 20.0014 6.24715 20.0014H6.74719C6.7847 20.0014 6.8222 19.9982 6.8597 19.9951C6.90658 19.9982 6.95346 20.0014 7.00034 20.0014H8.75049C9.44117 20.0014 10.0006 19.4419 10.0006 18.7513V16.001C10.0006 15.4478 10.4475 15.0009 11.0007 15.0009H13.0009C13.554 15.0009 14.0009 15.4478 14.0009 16.001V18.7513C14.0009 19.4419 14.5604 20.0014 15.251 20.0014H17.0168C17.0606 20.0014 17.1043 20.0014 17.1481 19.9982C17.1825 20.0014 17.2168 20.0014 17.2512 20.0014H17.7513C18.4419 20.0014 19.0014 19.4419 19.0014 18.7513V18.245C19.0107 18.1637 19.017 18.0793 19.017 17.9918L18.9951 12.9851H19.9952V12.9883Z",
    fill: "#171717",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.68cd76bced5cf40914f2dd7c156d5ead.svg";
export { ForwardRef as ReactComponent };